import { useState } from "react";
import { storage } from "../firebase";
import { ref, uploadBytes } from "firebase/storage";
import { auth } from "../firebase";
import toast from "react-hot-toast";

function FileUpload() {
    const [file, setFile] = useState(null);

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!file) return toast.error("Veuillez selectioner un document");

        const fileRef = ref(storage, `${auth.currentUser.uid}/${file.name}`);
        await uploadBytes(fileRef, file, {
            contentType: file.type,
            contentDisposition: `attachment; filename="${file.name}"`,
        }); toast.success("Le document à bien été soumis. Merci!");
    };

    return (

        <form onSubmit={handleUpload}>
            <div className="section-title-five">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="content">
                                <input className="btn" type="file" onChange={(e) => setFile(e.target.files[0])} />
                                <button type="submit"
                                    className="btn primary-btn rounded-full">Soumettre</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    );
}

export default FileUpload;